import {Builder, type DataSource} from "./";
import {ERedaccionTipo} from "../auxiliares";

class NewsBuilder extends Builder {
    public constructor(ds: DataSource) {
        super(ds, ERedaccionTipo.noticias);
    }
}
export {type NewsBuilder};

export default (ds: DataSource)=>new NewsBuilder(ds);
